import m from "./index295.js";
import { resolveComponent as i, createBlock as r, openBlock as a, Transition as f, withCtx as n, createElementBlock as b, createCommentVNode as d, createElementVNode as t, withKeys as y, normalizeStyle as u, renderSlot as s, createVNode as h } from "vue";
import v from "./index231.js";
const g = ["data-component"], k = ["aria-labelledby", "aria-describedby"], w = { class: "flex flex-col gap-8 flex-1 justify-center break-words min-h-24" }, $ = ["id"];
function B(e, o, C, M, _, N) {
  const c = i("ms-headline"), p = i("ms-close");
  return a(), r(f, {
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: n(() => [
      e.visible ? (a(), b("div", {
        key: 0,
        "data-component": e.$options.name,
        tabindex: "-1",
        class: "fixed top-0 left-0 flex items-center justify-center w-screen h-screen duration-300 ease-in-out bg-anthracite bg-opacity-90 backdrop-filter backdrop-blur z-overlay-canvas-modal"
      }, [
        t("div", {
          ref: "dialogRef",
          style: u({
            width: e.width,
            height: e.height
          }),
          role: "dialog",
          "aria-modal": "true",
          tabindex: "0",
          "aria-labelledby": e.labelledBy,
          "aria-describedby": e.describedBy,
          class: "relative flex max-h-screen gap-x-8 p-16 pr-8 overflow-auto bg-color-neutral-white rounded-10",
          onKeyup: o[1] || (o[1] = y((...l) => e.closeModal && e.closeModal(...l), ["esc"]))
        }, [
          t("div", w, [
            e.$slots.title ? (a(), r(c, {
              key: 0,
              id: e.labelledBy,
              type: "h4"
            }, {
              default: n(() => [
                s(e.$slots, "title")
              ]),
              _: 3
            }, 8, ["id"])) : d("", !0),
            t("section", { id: e.describedBy }, [
              s(e.$slots, "default")
            ], 8, $),
            s(e.$slots, "action")
          ]),
          t("button", {
            class: "w-24 h-24",
            "aria-label": "Dialog schließen",
            type: "button",
            onClick: o[0] || (o[0] = (...l) => e.closeModal && e.closeModal(...l))
          }, [
            h(p)
          ])
        ], 44, k)
      ], 8, g)) : d("", !0)
    ]),
    _: 3
  });
}
const E = /* @__PURE__ */ v(m, [["render", B]]);
export {
  E as default
};
